import request from '@/utils/request'
import router from '@/router'
import { getToken, setToken } from '@/utils/auth'
import { getSSIBaseData, getEnumList } from '@/api/base'
import commondata from '@/commondata.js'
function getToken_Token() {
  if (getToken() === undefined) {
    return undefined
  }
  return getToken().token
}
function getToken_bindPhone() {
  if (getToken() === undefined) {
    return undefined
  }
  return getToken().bindPhone
}
function getToken_bindSSI() {
  if (getToken() === undefined) {
    return undefined
  }
  return getToken().bindSSI
}
const state = {
  token: getToken_Token(),
  bindPhone: getToken_bindPhone(),
  bindSSI: getToken_bindSSI(),
  name: '',
  avatar: '',
  permission: null
}
const mutations = {
  SET_TOKEN: (state, data) => {
    state.token = data.token
    state.bindPhone = data.bindPhone
    state.bindSSI = data.bindSSI
  }
}

const actions = {
  // 重设Token信息
  resetToken({ commit }, data) {
    commit('SET_TOKEN', data)
    setToken(data)
  },
  wechatLogin({ commit }, info) {
    const { code, state, url } = info
    request({
      url: '/user/wechatLogin',
      method: 'post',
      data: { code: code, state: state }
    })
      .then(response => {
        if (!response.success) {
          return
        }
        if (!response.data) {
          return
        }
        commit('SET_TOKEN', response.data)
        setToken(response.data)
        router.replace(url)
      })
  },
  getWxLoginUrl({ commit }, url) {
    return new Promise((resolve, reject) => {
      request({
        url: '/user/GetWxLoginUrl',
        method: 'post',
        params: { url }
      })
        .then(response => {
          const { data } = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
    })
  },
  getSSIBaseData({ commit, state }) {
    return new Promise((resolve, reject) => {
      getSSIBaseData().then(response => {
        commondata.ssiBase = response.data
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getEnumList({ commit, state }) {
    return new Promise((resolve, reject) => {
      getEnumList().then(response => {
        commondata.enumList = response.data
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
